import { Pipe, PipeTransform } from '@angular/core';
import { IngredientChoiceGroup, OrderedItem } from 'ngx-web-api';
import { GroupIndexPipe } from './group-index.pipe';

@Pipe({
  name: 'canMoveToStepGroup',
})
export class CanMoveToStepGroupPipe implements PipeTransform {
  choiceGroupIndex = new GroupIndexPipe();

  transform(
    choiceGroup: IngredientChoiceGroup,
    item: OrderedItem,
    selectedChoiceGroup: IngredientChoiceGroup,
    groups: IngredientChoiceGroup[]
  ): boolean {
    if (Array.isArray(groups) && !!choiceGroup && !!selectedChoiceGroup && !!item) {
      const selectedChoiceGroupIndex = this.choiceGroupIndex.transform(selectedChoiceGroup, groups);
      const choiceGroupIndex = this.choiceGroupIndex.transform(choiceGroup, groups);

      return (
        choiceGroupIndex < selectedChoiceGroupIndex ||
        groups
          .filter((_v, i) => i >= selectedChoiceGroupIndex && i < choiceGroupIndex)
          .every((c: IngredientChoiceGroup) => !item.hasInvalidChoiceFor(c))
      );
    }
    return false;
  }
}
